<template>
  <div class="dsf-nationaldata-page-home">
    <template v-if="$root._isEn">
      <div class="dsf-nationaldata-page-home-newsCarousel" style="margin-bottom: 20px">
        <div
          class="content"
          :element-loading-text="$t('national.loadingText')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0)"
          v-loading="loading"
        >
          <el-carousel indicator-position="outside">
            <el-carousel-item :label="index + 1" v-for="(ne, index) in coverNews" :key="ne._id">
              <div class="carousel-box" style="height: 100%">
                <div class="carousel_box_nr" @click="handleJumpCurrentReport(ne)" style="height: 100%">
                  <div class="carousel-box_text">
                    <div class="carousel-box_text_title" style="font-size: 20px; font-weight: bold">{{ ne.fixed_EN_title }}</div>
                    <div class="carousel-box_text_value" v-html="ne.en_title"></div>
                  </div>
                  <div class="carousel-box_img">
                    <img :src="ne.img_url" alt="" />
                    <div class="img-title" v-if="ne.imgtitle">{{ ne.imgtitle }}</div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="calendar_content">
        <div class="calendar_content_left">
          <div class="calendar_content_icon">
            {{ currentDay }}
          </div>
          <div class="calendar_content_title" @click="toFbrc">
            <p>Release</p>
            <p>Schedule</p>
          </div>
          <div class="calendar_content_value">
            <div class="calendar_content_value_line">
              <div class="calendar_content_value_line_title">Today：</div>
              <div class="calendar_content_value_line_value">
                {{ todayLists.length ? todayLists[0].content : "No releases today." }}
              </div>
            </div>
            <div class="calendar_content_value_line">
              <div class="calendar_content_value_line_title">Tomorrow：</div>
              <div class="calendar_content_value_line_value">{{ tomorrowLists.length ? tomorrowLists[0].content : "No release tomorrow." }}</div>
            </div>
          </div>
        </div>
        <div class="calendar_content_right">
          <div class="calendar_content_right_item" v-for="(day, index) in nextSevenDays" :key="index">
            <p>{{ day.weekday }}</p>
            <p>{{ day.day }}</p>
          </div>
        </div>
      </div>
      <div class="dsf-nationaldata-page-home-en">
        <div class="home-left">
          <NationalCountReport />
          <!-- <DsfNationalDataview :select="select" oneceName="dataview" style="height: 418px"></DsfNationalDataview> -->
        </div>
        <div class="home-right">
          <DsfNationalDataview :select="select" oneceName="dataMap"></DsfNationalDataview>
          <!-- <DsfNationalNews style="margin-top: 18px"></DsfNationalNews> -->
        </div>
      </div>
    </template>
    <template v-else>
      <div class="dsf-nationaldata-page-home-cn">
        <DsfNationalNewsCarousel />
        <DsfNationalSevenCensuses />
        <div class="national-home-line">
          <NationalCountReportCn />
          <DsfNationalMonitorListCn />
        </div>
        <div class="national-home-line-all">
          <NationalVisualizationCn />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DsfNationalHome",
  props: {},
  data() {
    return {
      select: {},
      today: "",
      tomorrow: "",
      todayLists: [],
      tomorrowLists: [],
      currentDay: new Date().getDate(),
      nextSevenDays: [],
      loading: false,
      coverNews: [],
    };
  },
  created() {},
  mounted() {
    this.today = dsf.date.format(new Date(), "yyyy-mm-dd");
    this.tomorrow = dsf.date.format(Date.now() + 86400000, "yyyy-mm-dd");
    this.date = this.today;
    this.currentDay = new Date().getDate();
    this.getData();
    this.getCoverData();
    this.generateNextSevenDays();
  },
  watch: {},
  computed: {},
  methods: {
    toFbrc() {
      dsf.layer.openWindow(`https://www.stats.gov.cn/english/PressRelease/ReleaseCalendar/202512/t20251226_1962154.html`, "_blank");
    },
    getCoverData() {
      this.coverLoading = true;
      this.$http
        .get("/publicrelease/web/external/new/queryCMSArticles?code=zxfb&pagenum=1&pageSize=10")
        .done(res => {
          if (res?.success && res.data?.length > 0) {
            this.coverNews = res.data;
            _.forEach(this.coverNews, item => {
              item.titles = item.title?.split("+") || [];
              item.external_links = item.external_link?.split("+") || [];
              if (item.cover) {
                let coverData = JSON.parse(item.cover);
                item.img_url = location.origin + "/website" + coverData[0]?.relativePath;
              }
            });
          } else {
            this.coverEmpty = true;
            this.coverNews = [];
          }
        })
        .error(() => {
          this.coverEmpty = true;
          this.coverNews = [];
        })
        .always(() => {
          this.coverLoading = false;
        });
    },
    handleJumpCurrentReport(item) {
      if (item.external_link) {
        dsf.layer.openWindow(`${item.external_link}`, "_blank");
      }
    },
    generateNextSevenDays() {
      const days = [];
      const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      for (let i = 0; i < 7; i++) {
        const date = new Date();
        date.setDate(date.getDate() + i);

        const weekday = weekdays[date.getDay()];
        const day = dsf.date.format(date, "dd");

        days.push({
          weekday,
          day,
        });
      }

      this.nextSevenDays = days;
    },
    selectTargetAndTime(val) {
      this.select = val;
    },
    getData() {
      let dates = [this.today.replace(/-/g, "/") + " 00:00:00", this.tomorrow.replace(/-/g, "/") + " 23:59:59"];
      this.todayLists = [];
      this.tomorrowLists = [];
      this.$http
        .get("/publicrelease/web/external/queryAgendaByDate", {
          startDate: dates[0],
          endDate: dates[1],
        })
        .done(res => {
          if (res.success) {
            let todays = [],
              tomorrows = [];
            res.data.map(item => {
              let date = item.fb_time.slice(0, 10);
              if (date == this.today) {
                todays.push({
                  text: item.content,
                });
              } else if (date == this.tomorrow) {
                tomorrows.push({
                  text: item.content,
                });
              }
            });
            this.todayLists = todays;
            this.tomorrowLists = tomorrows;
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error(res => {
          dsf.layer.message(res.message, false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel-box_img {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  .img-title {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 12px 16px;
    // background: rgba(0, 0, 0, 0.5);
    color: #fff;
    text-align: left;
    font-size: 30px;
  }
}
</style>
